<nb-auth-block>
  <div class="alert alert-success" style="background-color: white">
    <h2 class="title">Reset Password Successful</h2>
  </div>
  <a class="btn btn-block btn-hero-success" routerLink="#/auth/login"><strong>Login</strong></a>
</nb-auth-block>



// WEBPACK FOOTER //
// ./src/app/pages-crypto/components-crypto/reset-password-message-crypto/reset-password-message-crypto.component.html